import { render, staticRenderFns } from "./WyMentionEditor.vue?vue&type=template&id=5f48bbb6&scoped=true&"
import script from "./WyMentionEditor.vue?vue&type=script&lang=js&"
export * from "./WyMentionEditor.vue?vue&type=script&lang=js&"
import style0 from "./WyMentionEditor.vue?vue&type=style&index=0&id=5f48bbb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f48bbb6",
  null
  
)

export default component.exports